import { useQuery } from '@tanstack/react-query'
import apiV2 from '../../service/apiV2.service'
import useReactQueryErrorEffect from './useReactQueryErrorEffect'

const useReactQueryPerson = () => {
  // Get Person All Vehicles Query
  const {
    data: personAllVehicles,
    refetch: refetchPersonAllVehicles,
    isLoading: isGetPersonAllVehiclesLoading,
    isFetching: isGetPersonAllVehiclesFetching,
    isError: isGetPersonAllVehiclesError,
    error: getPersonAllVehiclesError,
  } = useQuery({
    queryKey: ['personAllVehicles'],
    queryFn: () => apiV2.getPersonAllVehicles(),
    select: (response) => response.data,
  })

  useReactQueryErrorEffect(getPersonAllVehiclesError)

  return {
    isLoading: isGetPersonAllVehiclesLoading || isGetPersonAllVehiclesFetching,
    personAllVehicles: personAllVehicles || [],
    refetchPersonAllVehicles,
    isGetPersonAllVehiclesError,
    getPersonAllVehiclesError,
  }
}

export default useReactQueryPerson
